<app-admin-header></app-admin-header>
<div class="store-wrapper">
  <app-admin-sidebar></app-admin-sidebar>

  <!-- 🔹 Header + Modal Trigger -->
  <div class="header-bar">
    <h2>🚚 Send Products to Store</h2>
    <button class="open-modal-btn" (click)="showTransferModal = true">➕ New Transfer</button>
  </div>

  <!-- 🔹 Feedback -->
  <div *ngIf="feedbackMessage" [ngClass]="['toast', feedbackType]">{{ feedbackMessage }}</div>

  <!-- 🔹 Transfer Modal -->
  <div class="modal-backdrop" *ngIf="showTransferModal">
    <div class="modal">
      <h3>📦 Transfer Stock</h3>
      <form (ngSubmit)="sendProduct()" #transferForm="ngForm" class="modal-form">
        <label>From Store:</label>
        <select required [(ngModel)]="transfer.from_store_id" name="from_store_id">
          <option value="">-- Select --</option>
          <option *ngFor="let store of stores" [value]="store.id" [disabled]="store.id === transfer.to_store_id">
            {{ store.name }}
          </option>
        </select>

        <label>To Store:</label>
        <select required [(ngModel)]="transfer.to_store_id" name="to_store_id">
          <option value="">-- Select --</option>
          <option *ngFor="let store of stores" [value]="store.id" [disabled]="store.id === transfer.from_store_id">
            {{ store.name }}
          </option>
        </select>

        <label>Stock Item:</label>
        <select required [(ngModel)]="transfer.stock_item_id" name="stock_item_id" (ngModelChange)="watchSelectionChanges()">
          <option value="">-- Select --</option>
          <option *ngFor="let item of stockItems; trackBy: trackById" [value]="item.id">
            {{ item.name }}
          </option>
        </select>

        <div class="info-row" *ngIf="transfer.stock_item_id">
          <span class="available">Available: {{ availableQty ?? '—' }}</span>
          <span class="suggested">Suggested: {{ getLastTransferredQuantity(+transfer.stock_item_id) || '—' }}</span>
        </div>

        <label>Quantity:</label>
        <input type="number" [(ngModel)]="transfer.quantity" name="quantity" required min="1" />

        <label>Note (optional):</label>
        <input type="text" [(ngModel)]="transfer.note" name="note" />

        <div class="modal-actions">
          <button type="submit" [disabled]="transferForm.invalid || loading">Send Product</button>
          <button type="button" class="cancel" (click)="showTransferModal = false">Cancel</button>
        </div>
      </form>
    </div>
  </div>
<!-- ✅ Transfer Success Popup -->
<div class="success-popup" *ngIf="showSuccessPopup">
  ✅ Transfer Sent Successfully!
</div>

  <!-- 🔹 History Section -->
  <section class="history-section">
    <h3>📜 Store Transfer History</h3>

    <div class="filters">
      <input type="text" [(ngModel)]="searchTerm" placeholder="🔍 Search item, store, or note..." />
      <input type="date" [(ngModel)]="startDate" />
      <input type="date" [(ngModel)]="endDate" />
      <button (click)="exportToCSV()">⬇ Export</button>
    </div>

    <table *ngIf="filteredTransfers.length > 0" class="transfer-table">
  <thead>
    <tr>
      <th>From</th>
      <th>To</th>
      <th>Item</th>
      <th>Qty</th>
      <th>Note</th>
      <th>Date</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let transfer of filteredTransfers; trackBy: trackByTransferId">
      <td>
        <span class="label">From:</span>
        <span class="value">{{ getStoreName(transfer.from_store_id) }}</span>
      </td>
      <td>
        <span class="label">To:</span>
        <span class="value">{{ getStoreName(transfer.to_store_id) }}</span>
      </td>
      <td>
        <span class="label">Item:</span>
        <span class="value">{{ getItemName(transfer.stock_item_id) }}</span>
      </td>
      <td [ngClass]="{'high-qty': transfer.quantity > 50}">
        <span class="label">Qty:</span>
        <span class="value">{{ transfer.quantity }}</span>
      </td>
      <td>
        <span class="label">Note:</span>
        <span class="value">{{ transfer.note || '—' }}</span>
      </td>
      <td>
        <span class="label">Date:</span>
        <span class="value">{{ transfer.transferred_at | date: 'short' }}</span>
      </td>
    </tr>
  </tbody>
</table>


    <p *ngIf="!filteredTransfers.length">No transfers match your filter.</p>
  </section>
</div>
